module.exports = __webpack_public_path__ + "img/mobile-menu-open.aa7024ae.svg";